import Typography from '@shared/constants/Typography';
import { StyleSheet } from 'react-native';

export const feedbackStateStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      alignContent: Typography.textAlign.centerAlign,
      flex: 1,
      
    },
    subContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap16,
      alignItems: Typography.textAlign.centerAlign,
    },
    titleContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap8,
      alignItems: Typography.textAlign.centerAlign
    },
    title: {
      fontSize: Typography.fontSize.fontSize16,
      color: theme.title,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight24,
    },
    subTitle: {
      fontSize: Typography.fontSize.fontSize14,
      color: theme.subTitle,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.regular,
      lineHeight: Typography.lineHeight.lineHeight24,
    },
  });
